import React from 'react';
import PropTypes from 'prop-types';
import styles from './ProjectInfo.module.scss';
import i18n from '../../i18n';

const ProjectInfo = ({ constructionStart, moveIn, documentDownload }) => {
    if (!constructionStart && !moveIn && !documentDownload.url) {
        return null;
    }

    return (
        <div className={styles['ProjectInfo']}>
            <div className={styles['ProjectInfo__Wrap']}>
                {constructionStart && (
                    <div className={styles['ProjectInfo__Info']}>
                        <strong>Byggstart</strong> {constructionStart}
                    </div>
                )}
                {moveIn && (
                    <div className={styles['ProjectInfo__Info']}>
                        <strong>Inflyttning</strong> {moveIn}
                    </div>
                )}
                {documentDownload.url && (
                    <div className={styles['ProjectInfo__Document']}>
                        <a href={documentDownload.url}>
                            {documentDownload.name ||
                                i18n.t('projectInfo.documentName')}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

ProjectInfo.propTypes = {
    constructionStart: PropTypes.string,
    moveIn: PropTypes.string,
    documentDownload: PropTypes.object,
};

ProjectInfo.defaultProps = { documentDownload: {} };

export default ProjectInfo;
